export const tradeAdapter = async (resTrade) => ({
  sale: resTrade,
});
